import { render, staticRenderFns } from "./ShadanChat.vue?vue&type=template&id=afdf42f6"
import script from "./ShadanChat.vue?vue&type=script&lang=js"
export * from "./ShadanChat.vue?vue&type=script&lang=js"
import style0 from "./ShadanChat.vue?vue&type=style&index=0&id=afdf42f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports